import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import FolderIcon from "@material-ui/icons/Folder";
import PageviewIcon from "@material-ui/icons/Pageview";
import TextField from "@material-ui/core/TextField";
import AssignmentIcon from "@material-ui/icons/Assignment";
import { Link } from "@reach/router";
import Icon from "@material-ui/core/Icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import ImageModal from "./ImageModal";
import SERVER_ADDRESS from "../../../../config";
import { CardMediaStepper, ModelButton } from "../listpage";

import {
  EditTiaowenDialogButton,
  EditGoujianImageDialogButton,
  EditGoujianDialogButton
} from "../../utils";

const useStyles = makeStyles(theme => ({
  media: {
    width: "100%"
  },

  cardheader: {
    backgroundColor: theme.palette.secondary.main
  },
  actions: {
    color: theme.palette.secondary.light,
    display: "flex"
  },
  grow: {
    flexGrow: 1
  },
  textfield: {
    marginRight: theme.spacing(2)
  }
}));

//获取构件位置信息图
function useGoujianPosition(initValue, goujianId) {
  const [goujianPosition, setGoujianPosition] = useState(initValue);
  const fetchUrl = `${SERVER_ADDRESS}/api/goujianimages/?description=位置关系图&category=图纸&goujian__id=${goujianId}`;
  useEffect(() => {
    async function getGoujianPosition() {
      const goujianPosition = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include"
      }).then(res => {
        return res.json();
      });
      //使用第0张图,确保最早上传的位置构件图作为展示用
      setGoujianPosition(goujianPosition[0]);
    }
    getGoujianPosition();
  }, [goujianId]);
  return goujianPosition;
}

//主要的Card组件,显示构件详情
function TestCard(props) {
  const classes = useStyles();
  const { goujian, postionMedia, submitAnswer, submitButtonRef } = props;
  const [showAnswer, setShowAnswer] = useState(false);

  //打开查看大图窗口
  const [modalOpen, setModalOpen] = useState(false);
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const goujianPosition = useGoujianPosition({}, goujian.id);
  const [mediaType, toggleMediaType] = useState(postionMedia ? true : false);
  const [answer, setAnswer] = useState("");
  const {
    name,
    sketch,
    category,
    description,
    id,
    sketch_thumbnail
  } = props.goujian;

  const correctIcon =
    name === answer ? (
      <SvgIcon
        nativecolor="white"
        style={{
          color: "green"
        }}
      >
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </SvgIcon>
    ) : (
      <SvgIcon
        nativecolor="white"
        style={{
          color: "red"
        }}
      >
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </SvgIcon>
    );

  return (
    <div>
      <Card raised>
        <CardHeader
          className={classes.cardheader}
          avatar={
            <Avatar
              aria-label="类型"
              className={classes.avatar}
              src={sketch_thumbnail}
            />
          }
          action={
            showAnswer ? (
              <IconButton
                title="详细信息"
                onClick={() => {
                  window.open(`/info/goujian/${id}`);
                }}
              >
                {/* <MoreVertIcon /> */}
                <SvgIcon>
                  <path d="M12,2C6.477,2,2,6.477,2,12s4.477,10,10,10s10-4.477,10-10S17.523,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z" />
                </SvgIcon>
              </IconButton>
            ) : null
          }
          title={showAnswer ? `答案:${name}` : "答案:提交后查看"}
        />
        <CardMedia
          className={classes.media}
          image={
            mediaType && Object.keys(goujianPosition).length !== 0
              ? goujianPosition.thumbnail
              : sketch_thumbnail
          }
          title="点击查看大图"
          component="img"
          onClick={() => {
            setModalOpen(true);
          }}
        />
        <CardContent>
          {Object.keys(goujianPosition).length !== 0 ? (
            <CardMediaStepper
              toggleImage={() => {
                toggleMediaType(!mediaType);
              }}
            />
          ) : null}

          <Typography>{showAnswer ? description : null}</Typography>
          <TextField
            label="构件名称"
            value={answer}
            onChange={e => {
              setAnswer(e.target.value);
            }}
            margin="normal"
            className={classes.textfield}
            disabled={showAnswer}
          />
        </CardContent>

        <CardActions className={classes.actions}>
          {goujian.obj_model ? (
            <ModelButton obj_model={goujian.obj_model} />
          ) : null}

          <div className={classes.grow} />
          <Button
            ref={submitButtonRef}
            onClick={() => {
              submitAnswer(name, answer);
              setShowAnswer(true);
            }}
            color="secondary"
            variant="contained"
            size="small"
            disabled={showAnswer}
          >
            提交
          </Button>
          {showAnswer ? correctIcon : null}
        </CardActions>
      </Card>
      <ImageModal
        open={modalOpen}
        handleClose={handleModalClose}
        src={
          mediaType && Object.keys(goujianPosition).length !== 0
            ? goujianPosition.image
            : sketch
        }
        width={
          mediaType && Object.keys(goujianPosition).length !== 0
            ? "100%"
            : "50%"
        }
      />
    </div>
  );
}
export default TestCard;
